import React from 'react';
import { AboutWidget } from './AboutWidget/AboutWidget';
import { ImportantDatesWidget } from './ImportantDatesWidget/ImportantDatesWidget';
import { PrizesWidget } from './PrizesWidget/PrizesWidget';
import { FaqWidget } from './FaqWidget/FaqWidget';

type GeneralTabProps = {
  challengeId: number;
};

/**
 * GeneralTab - contains a few separate widgets, when edidting publish/unpublish buttons are disabled
 *
 * User Roles:
 * - Only Entity users (isEntity) can edit challenge widgets, other roles have read-only access
 *
 * Edit Rules by Status (from Confluence: Challenge create and edit functionality):
 *
 * | Widget               | Draft | Published | Active | Finished |
 * |----------------------|-------|-----------|--------|----------|
 * | AboutWidget          | Yes*  | Yes*      | Yes*   | No       |
 * | ImportantDatesWidget | Yes   | No        | No     | No       |
 * | PrizesWidget         | Yes   | Yes       | Yes    | No       |
 * | FaqWidget            | Yes   | Yes       | Yes    | No       |
 *
 * *AboutWidget: Text fields editable, but main fields (Customer Type, Contest Type, Price)
 *  are disabled outside Draft status via `disabledEditMainFields` prop.
 */
const GeneralTab = ({ challengeId }: GeneralTabProps) => {
  return (
    <div>
      <AboutWidget challengeId={challengeId} />
      <ImportantDatesWidget challengeId={challengeId} />
      <PrizesWidget challengeId={challengeId} />
      <FaqWidget challengeId={challengeId} />
    </div>
  );
};

export { GeneralTab };
